export default __webpack_public_path__ + "static/media/first_info_letter_2027.195978a7.pdf";